import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ReserveAction } from '../../../actions/reserve.action';
import { PhotoRequestSelectionPage } from '../selection/photo-request-selection';
import { BadgeStore } from '../../../stores/badge-store';
import { AbstractPage } from '../../_com/abstract-page';
import Utils from '../../../_com/utils';

/**
 * Generated class for the PhotoRequestListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
	selector: 'page-photo-request-list',
	templateUrl: 'photo-request-list.html',
})
export class PhotoRequestListPage extends AbstractPage {

	data = [];
	constructor(public navCtrl: NavController, public navParams: NavParams, private reserveAction:ReserveAction, private badgeStore:BadgeStore) {
		super();
	}

	ionViewDidEnter() {
		this.refresh();
	}

	/**
	 * リフレッシュ
	 */
	refresh(){
		this.reserveAction.getListPhotoRequest().subscribe(data=>{
			this.data = data.data;
			this.badgeStore.setBadgePhotoRequest(data.data.length);
		});
	}

	/**
	 * 予約日付
	 */
	getReserveDate(d){
		
		if(!d) return;
		var d = d.Reserve.datetime.date;
		return Utils.date.format(Utils.date.getDateFromHyphen(d), "M/d(EEEE)");
	}

	goSelection(d){
		this.navCtrl.push(PhotoRequestSelectionPage, d);
	}
}


// WEBPACK FOOTER //
// ./src/pages/photo-request/list/photo-request-list.ts